import { gql } from '@apollo/client';

export const PUBLISH_INSTAGRAM_DIRECT_IMAGE = gql`
    mutation PublishInstagramDirectImage($input: PublishInstagramDirectImageInput!) {
        publishInstagramDirectImage(input: $input) {
            ... on PublishResultPayload {
                workflow {
                    id
                    executionId
                    startDate
                    status {
                        state
                        message
                    }
                }
            }
            ... on PublishError {
                code
                message
            }
        }
    }
`;
